// Ideally this file is not used directly. But rather, you go through the entry points
export { default, type LinkProps } from './components/link';
